import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#333333",
        },
        mode: "light", // modalità chiara
        background: {
            default: "#fdfdfd", // fondo quasi bianco
            paper: "#ffffff" // sfondi delle card bianchi
        },
        text: {
            primary: "#1a1a1a", // grigio antracite testi primari
            secondary: "#333333" // testi secondari
        }
    },
    typography: {
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        h1: { color: "#1a1a1a" },
        h2: { color: "#1a1a1a" },
        h3: { color: "#1a1a1a" },
        h4: { color: "#1a1a1a" },
        h5: { color: "#1a1a1a" },
        h6: { color: "#1a1a1a" },
        body1: { color: "#1a1a1a" },
        body2: { color: "#333333" }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none", // niente maiuscole automatiche
                    color: "#1a1a1a"
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    color: "#1a1a1a"
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
                }
            }
        }
    }
});

export default theme;